module.exports = __webpack_public_path__ + "img/p4.c112bd21.png";